import { Link } from "react-router-dom";
import DecoCorners from "../components/DecoCorners";
import usePageMeta from "../hooks/usePageMeta";

const PORTRAIT = "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/ipgrh8hm_UK%20Erotic%20Hypnotist.jpg";
const WATCH = "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/qmzz8za3_Cleo%20erotic%20hypnosis%20pocket%20watch%202.jpg";
const CARTOON = "https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/dedg5tlg_WhatsApp%20Image%202026-06-15%20at%2023.10.29%20%281%29.jpeg";

export default function About() {
  usePageMeta({title:"About Queen Cleopatra",description:"Meet Queen Cleopatra - London-based British erotic hypnotist with a crisp English accent and years of professional experience guiding adults through consensual erotic trance.",path:"/about"});
  return (
    <div data-testid="page-about">
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-7">
            <div className="eyebrow mb-5">The Practitioner</div>
            <h1 className="font-serif text-5xl md:text-7xl text-cream leading-[1] mb-8">
              I am <em className="text-gold">Cleopatra</em>.
            </h1>
            <div className="space-y-5 text-cream/75 leading-relaxed">
              <p>
                I am Queen Cleopatra, a <strong className="text-cream">London-based British erotic hypnotist</strong> with a crisp English accent and years of professional experience guiding adults through consensual erotic trance. My practice centres on safety, clear boundaries and bespoke inductions tailored to each client's needs.
              </p>
              <p>
                Sessions move at the pace your body invites. I work with paced breath, layered language and steady authority - never demand, never rush. What we explore is decided together, in conversation, before any trance begins.
              </p>
              <p>
                When recording is part of the brief, it is held to the same standard as the session itself: explicitly consented, professionally produced, and released only on the terms you sign for.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-2 gap-px bg-[#c9a04b]/15">
              {[
                ["Safewords", "Agreed before every session."],
                ["Aftercare", "Always offered, always tailored."],
                ["Confidentiality", "Discretion is non-negotiable."],
                ["Recording", "Only with signed release."],
              ].map(([t, d]) => (
                <div key={t} className="bg-charcoal p-6">
                  <div className="eyebrow mb-2">{t}</div>
                  <div className="text-sm text-cream/70">{d}</div>
                </div>
              ))}
            </div>

            <Link to="/book" className="btn-primary mt-10 inline-flex" data-testid="about-book-cta">Reserve a Session</Link>

            {/* Playful cartoon accent - a wink to long-time readers */}
            <figure className="mt-16 border-t border-[#c9a04b]/15 pt-10" data-testid="about-cartoon">
              <div className="eyebrow mb-5">An Aside</div>
              <div className="grid md:grid-cols-12 gap-6 items-center">
                <div className="md:col-span-7 bg-cream border border-[#c9a04b]/25 p-3 md:p-5">
                  <img src={CARTOON} alt="Cartoon - a sly Queen Cleopatra mid-induction" className="w-full h-auto" />
                </div>
                <figcaption className="md:col-span-5 text-sm text-cream/65 leading-relaxed">
                  A panel from the comic archive. The practice is held with care -
                  but I have a sense of humour about it, too.
                </figcaption>
              </div>
            </figure>
          </div>

          <div className="md:col-span-5">
            <div className="relative">
              <div className="aspect-[4/5] border border-[#c9a04b]/25 overflow-hidden">
                <img src={PORTRAIT} alt="Queen Cleopatra portrait - London-based British erotic hypnotist" className="w-full h-full object-cover" />
              </div>
              <DecoCorners size={38} opacity={0.85} inset={-7} testid="about-portrait-deco" />
            </div>
            <div className="relative mt-6">
              <div className="aspect-square border border-[#c9a04b]/15 overflow-hidden">
                <img src={WATCH} alt="Hands holding a gold pocket watch chain - the pendulum in motion" className="w-full h-full object-cover" />
              </div>
              <DecoCorners size={30} opacity={0.7} inset={-6} testid="about-watch-deco" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
